import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';

export const cloudECounterRoutes = [{
    path: '/cloud-e-counter/',
    redirect: routeName.CLOUD_E_COUNTER_HOME,
    component: () => import('@/components/layout/cloudECounter/LayoutCloudECounter.vue'),
    children: [
        {
            path: 'home',
            name: routeName.CLOUD_E_COUNTER_HOME,
            component: () => import('@/views/cloudECounter/home.vue'),
            meta: {
                auth: false,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
            },
        },
        {
            path: 'record/applicant-change',
            name: routeName.CLOUD_E_COUNTER_RECORD_APPLICANT_CHANGE,
            component: () => import('@/views/cloudECounter/detail/applicant.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
            },
        }, {
            path: 'record/loan',
            name: routeName.CLOUD_E_COUNTER_RECORD_LOAN,
            component: () => import('@/views/cloudECounter/detail/loan.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
            },
        }, {
            path: 'record/name',
            name: routeName.CLOUD_E_COUNTER_RECORD_NAME,
            component: () => import('@/views/cloudECounter/detail/name.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
            },
        }, {
            path: 'record/beneficiary',
            name: routeName.CLOUD_E_COUNTER_RECORD_BENEFICIARY,
            component: () => import('@/views/cloudECounter/detail/beneficiary.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
            },
        },
        {
            path: 'policy-basic',
            name: routeName.CLOUD_E_COUNTER_POLICY,
            component: () => import('@/views/cloudECounter/policy/Index.vue'),
            meta: {
                auth: true,
                metaTitle: '選擇保單',
                leaveAlert: true,
            },
        },
        {
            path: 'confirm',
            name: routeName.CLOUD_E_COUNTER_CONFIRM,
            component: () => import('@/views/cloudECounter/confirm/Index.vue'),
            meta: {
                auth: true,
                metaTitle: '確認輸入資料',
                leaveAlert: true,
            },
        },
        {
            path: 'otp',
            name: routeName.CLOUD_E_COUNTER_APPLY_OTP,
            component: () => import('@/views/cloudECounter/applyOtpValid.vue'),
            meta: {
                auth: true,
                metaTitle: '行動電話驗證',
                leaveAlert: true,
                unableBack: true,
                // beforeEnter: (to, from, next) => {
                //     const whiteList = [routeName.CLOUD_E_COUNTER_PERIOD, routeName.CLOUD_E_COUNTER_LOAN_CONTACT_INFO_CHECK];
                //     const guideRoute = guideRoutes(from, whiteList, false);
                //     next(guideRoute === true ? true : routeName.CLOUD_E_COUNTER_HOME);
                // },
            },
        },
        {
            path: 'otp',
            name: routeName.CLOUD_E_COUNTER_APPLY_FINISH,
            component: () => import('@/views/cloudECounter/finish.vue'),
            meta: {
                auth: true,
                metaTitle: '行動電話驗證',
                leaveAlert: true,
            },
        },
        {
            path: 'period',
            name: routeName.CLOUD_E_COUNTER_PERIOD,
            component: () => import('@/views/cloudECounter/reservePeriod.vue'),
            meta: {
                auth: true,
                metaTitle: '預約視訊時間',
                leaveAlert: true,
            },
        },
        {
            path: 'phone',
            name: routeName.CLOUD_E_COUNTER_PHONE,
            component: () => import('@/views/cloudECounter/reservePhone.vue'),
            meta: {
                auth: true,
                metaTitle: '預約視訊驗證',
                leaveAlert: true,
            },
        },
    ],
}];

export const cloudECounterApplicantChangeRoutes = [{
    path: '/cloud-e-counter/applicant-change',
    component: () => import('@/components/layout/cloudECounter/LayoutCloudECounter.vue'),
    children: [
        {
            path: 'info',
            name: routeName.CLOUD_E_COUNTER_APPLICANT_CHANGE_INFO,
            component: () => import('@/views/cloudECounter/applicantChange/form.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.APPLICANT_CHANGE,
            },
        },
    ],
}];
export const cloudECounterApplicantInsuredNameChangeRoutes = [{
    path: '/cloud-e-counter/applicant-insured-name-change',
    component: () => import('@/components/layout/cloudECounter/LayoutCloudECounter.vue'),
    children: [
        {
            path: 'info',
            name: routeName.CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_INFO,
            component: () => import('@/views/cloudECounter/applicantInsuredNameChange/change.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.APPLICANT_INSURED_NAME_CHANGE,
            },
        },
        {
            path: 'confirm',
            name: routeName.CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_CONFIRM,
            component: () => import('@/views/cloudECounter/confirm/applicantInsuredNameChangeConfirm.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.APPLICANT_INSURED_NAME_CHANGE,
            },
        },
    ],
}];
export const cloudECounterReserveRoutes = [
    {
        path: '/cloud-e-counter/reserve/reserve',
        name: routeName.CLOUD_E_COUNTER_RESERVE_RESERVE,
        component: () => import('@/views/cloudECounter/reserve/reserve.vue'),
        meta: {
            auth: false,
            metaTitle: '雲端e櫃檯',
            leaveAlert: true,
        },
    },
    {
        path: '/cloud-e-counter/reserve/',
        redirect: routeName.CLOUD_E_COUNTER_RESERVE_HOME,
        component: () => import('@/components/layout/cloudECounter/LayoutCloudECounterReserve.vue'),
        children: [
            {
                path: 'home',
                name: routeName.CLOUD_E_COUNTER_RESERVE_HOME,
                component: () => import('@/views/cloudECounter/reserve/home.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: true,
                    // code: 'RESERVE_HOME',
                },
            },
            {
                path: 'notice',
                name: routeName.CLOUD_E_COUNTER_RESERVE_NOTICE,
                component: () => import('@/views/cloudECounter/reserve/notice.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_HOME];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'record',
                name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD,
                component: () => import('@/views/cloudECounter/reserve/record.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_HOME, routeName.CLOUD_E_COUNTER_RESERVE_NOTICE];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'record-applicant-change',
                name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE,
                component: () => import('@/views/cloudECounter/reserve/record/applicant.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE, routeName.CLOUD_E_COUNTER_RESERVE_RECORD];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'record-loan',
                name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_LOAN,
                component: () => import('@/views/cloudECounter/reserve/record/loan.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE, routeName.CLOUD_E_COUNTER_RESERVE_RECORD];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'record-beneficiary',
                name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_BENEFICIARY,
                component: () => import('@/views/cloudECounter/reserve/record/beneficiary.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE, routeName.CLOUD_E_COUNTER_RESERVE_RECORD];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'record-name',
                name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_NAME,
                component: () => import('@/views/cloudECounter/reserve/record/name.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE, routeName.CLOUD_E_COUNTER_RESERVE_RECORD];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'video',
                name: routeName.CLOUD_E_COUNTER_RESERVE_VIDEO,
                component: () => import('@/views/cloudECounter/reserve/video.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: true,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE, routeName.CLOUD_E_COUNTER_RESERVE_RECORD_NAME, routeName.CLOUD_E_COUNTER_RESERVE_RECORD_LOAN, routeName.CLOUD_E_COUNTER_RESERVE_RECORD_BENEFICIARY];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            {
                path: 'identityRecognition',
                name: routeName.CLOUD_E_COUNTER_RESERVE_IDENTITY_RECOGNITION,
                component: () => import('@/views/cloudECounter/reserve/identityRecognition.vue'),
                meta: {
                    auth: true,
                    metaTitle: '雲端e櫃檯',
                    leaveAlert: true,
                },
                // beforeEnter: (to, from, next) => {
                //     const whiteList = [routeName.CLOUD_E_COUNTER_RESERVE_VIDEO];
                //     const guideRoute = guideRoutes(from, whiteList, false);
                //     next(guideRoute);
                // },
            }],
    }];

export const beneficiaryChangeRoutes = [{
    path: '/cloud-e-counter/beneficiary/',
    redirect: routeName.CLOUD_E_COUNTER_HOME,
    component: () => import('@/components/layout/cloudECounter/LayoutCloudECounter.vue'),
    children: [
        {
            path: 'bene-info',
            name: routeName.CLOUD_E_BENEFICIARY_INFO,
            component: () => import('@/views/cloudECounter/beneficiary/beneficiaryInfo.vue'),
            meta: {
                auth: false,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.BENEIFCIARY,
            },
        }],
}];
export const cloudECounterLoanRoutes = [{
    path: '/cloud-e-counter/loan/',
    redirect: routeName.CLOUD_E_COUNTER_HOME,
    component: () => import('@/components/layout/cloudECounter/LayoutCloudECounter.vue'),
    children: [
        {
            path: 'notice',
            name: routeName.CLOUD_E_COUNTER_LOAN_NOTICE,
            component: () => import('@/views/cloudECounter/loan/notice.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'selectPolicy',
            name: routeName.CLOUD_E_COUNTER_LOAN_SELECT_POLICY,
            component: () => import('@/views/cloudECounter/loan/selectPolicy.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'check',
            name: routeName.CLOUD_E_COUNTER_LOAN_CHECK,
            component: () => import('@/views/cloudECounter/loan/check.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'contactInfoCheck',
            name: routeName.CLOUD_E_COUNTER_LOAN_CONTACT_INFO_CHECK,
            component: () => import('@/views/cloudECounter/loan/contactInfoCheck.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                // code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'reservePhone',
            name: routeName.CLOUD_E_COUNTER_LOAN_RESERVE_PHONE,
            component: () => import('@/views/cloudECounter/loan/reservePhone.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'finish',
            name: routeName.CLOUD_E_COUNTER_LOAN_FINISH,
            component: () => import('@/views/cloudECounter/loan/finish.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                // code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'selectSpecific',
            name: routeName.CLOUD_E_COUNTER_LOAN_SELECT_SPECIFIC,
            component: () => import('@/views/cloudECounter/loan/selectSpecific.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
        {
            path: 'specific',
            name: routeName.CLOUD_E_COUNTER_LOAN_SPECIFIC,
            component: () => import('@/views/cloudECounter/loan/specific.vue'),
            meta: {
                auth: true,
                metaTitle: '雲端e櫃檯',
                leaveAlert: true,
                code: aplCatlCode.LOAN,
            },
        },
    ],
}];
